/**
 * Analytics section header — title + descriptive paragraph + optional trailing
 * slot (e.g., FixtureBadge). Mirrors GoodData's section pattern. Used inside
 * `pdfTargetRef` so the descriptions land in PDF exports alongside the widgets.
 */

import type { ReactNode } from 'react';

export interface SectionHeaderProps {
  title: string;
  description: string;
  trailing?: ReactNode;
}

export function SectionHeader({ title, description, trailing }: SectionHeaderProps): JSX.Element {
  return (
    <div className="dls-px-1 dls-space-y-1 dls-pt-2">
      <div className="dls-flex dls-items-center dls-gap-2">
        <div className="dls-text-[11px] dls-font-semibold dls-uppercase dls-tracking-wider dls-text-muted-foreground/70">
          {title}
        </div>
        {trailing}
      </div>
      <p className="dls-text-xs dls-text-muted-foreground dls-leading-relaxed dls-max-w-3xl">
        {description}
      </p>
    </div>
  );
}
